export const DOCUMENTATION_NAV_STORAGE_KEY = 'city-sense-frontend-navigation-collapsed-documentation'

export const MAX_COMPRESSED_HEADER = 64 * 1024 * 1024
export const MAX_UNPACKED_HEADER = 256 * 1024 * 1024
export const MAX_GEOJSON_BYTES = 256 * 1024 * 1024
export const MAX_PHOTO_BYTES = 64 * 1024 * 1024
export const MAX_ARCHIVE_ENTRIES = 5_000_000
export const LARGE_FILE_BYTES = 50 * 1024 * 1024 * 1024
export const PREVIEW_CACHE_BYTES = 128 * 1024 * 1024
export const PREFETCH_AHEAD = 8
export const PREFETCH_BEHIND = 2
export const MAX_CACHED_FRAMES = PREFETCH_AHEAD + PREFETCH_BEHIND + 1
export const DECODE_CONCURRENCY = 3
export const STAGE_MAX_WIDTH = 1920
export const STAGE_MAX_HEIGHT = 1080
export const PLAY_INTERVAL_MS = 350
export const PAGE_STEP = 10
export const FULL_UPLOAD_POINT_LIMIT = 100_000
export const VIEWPORT_BUFFER_RATIO = 0.1
export const FIT_WIDTH_RATIO = 0.8
export const MIN_PANE = 160
